var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "consent-optin-update-form" },
    [
      _c(
        "h1",
        {
          staticClass:
            "consent-optin-update-form__title typographies-heading-h1"
        },
        [_vm._v("\n        " + _vm._s(_vm.labels.title) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass:
            "consent-optin-update-form__information typographies-paragraph-medium-regular"
        },
        [_vm._v("\n        " + _vm._s(_vm.labels.information) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "consent-optin-update-form__campaigns" },
        [
          _c("CompassSwitch", {
            staticClass: "consent-optin-update-form__campaigns-swicth",
            attrs: {
              label: _vm.labels.switchButtons.email.label,
              orientation: "left"
            },
            model: {
              value: _vm.currentConsent.marketing.email,
              callback: function($$v) {
                _vm.$set(_vm.currentConsent.marketing, "email", $$v)
              },
              expression: "currentConsent.marketing.email"
            }
          }),
          _vm._v(" "),
          _c("CompassSwitch", {
            staticClass: "consent-optin-update-form__campaigns-swicth",
            attrs: {
              label: _vm.labels.switchButtons.sms.label,
              orientation: "left"
            },
            model: {
              value: _vm.currentConsent.marketing.sms,
              callback: function($$v) {
                _vm.$set(_vm.currentConsent.marketing, "sms", $$v)
              },
              expression: "currentConsent.marketing.sms"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("CompassButton", {
        staticClass: "consent-optin-update-form__button",
        attrs: { label: _vm.labels.button },
        on: { click: _vm.updateConsent }
      }),
      _vm._v(" "),
      _c("preloader", { attrs: { display: _vm.isLoading } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }